import {Component} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {ToastModule} from 'primeng/toast';
import {ProgressBarService} from "./core/services/progress-bar.service";

@Component({
    selector: 'zenith-root',
    standalone: true,
    imports: [RouterOutlet, ToastModule],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {
    title = 'zenith';
    loading = this.progressBarService.loading;

    constructor(private progressBarService: ProgressBarService) {
    }

}
